export const USES_CHARGE_POLLING = 0x1;
export const USES_CHARGE_VALIDATE = 0x2;
export const USES_VALIDATE_POLLING = 0x4;
export const USES_ORDER_REFERENCE = 0x8;
